import { Link } from "react-router-dom";

const events = [
  {
    name: "Wholesale World Congress 2026",
    shortName: "WWC Madrid",
    date: "September 16–18, 2026",
    city: "Madrid, Spain",
    description: "One of the largest global wholesale telecom events.",
    image: "https://images.unsplash.com/photo-1539037116277-4db20889f2d4?w=800",
  },
  {
    name: "Middle East GCCM 2026",
    shortName: "U/GCCM Oman",
    date: "November 1–4, 2026",
    city: "Muscat, Oman",
    description: "Focused on carrier relations, connectivity, messaging, voice, SMS, cloud and infrastructure.",
    image: "https://images.unsplash.com/photo-1578895101408-1a36b834405b?w=800",
  },
];

interface UpcomingEventsProps {
  showSeeAll?: boolean;
}

const UpcomingEvents = ({ showSeeAll = true }: UpcomingEventsProps) => {
  return (
    <section id="events" className="section-shell">
      <div className="mx-auto max-w-[1280px]">
        <div className="text-center">
          <h2 className="why-title">Upcoming Events</h2>
        </div>
        <div className="mx-auto mt-[38px] grid max-w-[760px] gap-5 md:grid-cols-2">
          {events.map((e) => (
            <article
              key={e.name}
              className="why-card flex flex-col p-[30px] text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
            >
              <div className="text-[13px] font-bold uppercase tracking-[0.08em] text-[#00C4A0]">
                {e.date}
              </div>
              <h3 className="mt-3 font-display text-[22px] font-bold leading-[1.2] tracking-tight text-foreground">
                {e.name}
              </h3>
              <p className="mt-2 text-[14px] font-medium text-muted-foreground">{e.city}</p>
              <p className="mt-3 text-[14px] leading-relaxed text-muted-foreground">{e.description}</p>
              <Link
                to="/contact"
                className="mt-auto inline-flex w-full items-center justify-center rounded-[6px] bg-primary px-[31px] py-[13px] text-[15px] font-bold text-primary-foreground shadow-soft transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lift pt-[13px]"
                style={{ marginTop: "1.5rem" }}
              >
                Contact Sales
              </Link>
            </article>
          ))}
        </div>
        {showSeeAll && (
          <div className="mt-10 text-center">
            <Link
              to="/events"
              className="inline-flex items-center gap-1 text-[14px] font-bold text-foreground transition-colors hover:text-primary"
            >
              See all events →
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

export default UpcomingEvents;